import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import Options from '../components/Options';

export class WidgetContainer extends React.Component {
	render() {
		return <Options options={this.props.options} />;
	}
}

const mapStateToProps = state => {
	return {
		options: state.options
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

WidgetContainer.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired
		})
	).isRequired
};

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx